import React from 'react';
import ReactModal from 'react-modal';
import ClienteForm from './ClienteForm';
import "react-datepicker/dist/react-datepicker.css";

ReactModal.setAppElement('#root');

class ClienteNuevo extends React.Component {
    constructor () {
      super();
      this.state = {
        showModal: false
      };
      
      this.handleOpenModal = this.handleOpenModal.bind(this);
      this.handleCloseModal = this.handleCloseModal.bind(this);
    }
    
    handleOpenModal () {
      this.setState({ showModal: true });
    }
    
    handleCloseModal () {
      this.setState({ showModal: false });
    }
    
    
    render () {
      return (
        <div>
          <button className="btn btn-success" onClick={this.handleOpenModal}>Crear Cliente</button>
          <ReactModal
             isOpen={this.state.showModal}
             contentLabel="Nuevo CLiente"
             htmlOpenClassName="col-md-6"
          >
            <button className="btn btn-danger" onClick={this.handleCloseModal}>Cerrar</button>
            <ClienteForm/>
          </ReactModal>
        </div>
      );
    }
  }

  export default ClienteNuevo;